export default __webpack_public_path__ + "static/media/motivation-colored.725fbd1f.svg";